import * as React from "react";
import { forwardRef } from "react";
import { clsx } from 'clsx';
function _DrillingRigCustom(props, ref) {
    const { className, ...rest } = props;
    const classes = clsx('go-icon', className);
    return React.createElement("span", { className: classes, ref: ref, ...rest },
        React.createElement("svg", { width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24" },
            React.createElement("path", { stroke: "currentColor", d: "M4.78 20v-1.362h2.11M19.55 20v-1.362H17.79m0 0-1.777-5.787m1.777 5.787-5.45-3.457m5.45 3.457h-5.45m-5.45 0 1.776-5.787M6.89 18.638l5.45-3.457m-5.45 3.457h5.45M9 6.043h6.33m.684 6.808-3.673 2.33m3.673-2.33h-3.673m3.673 0-1.388-4.518M8.667 12.85l3.674 2.33m-3.674-2.33h3.674m-3.674 0 1.388-4.518m2.286 6.848v3.457m0-5.787 2.285-4.518m-2.285 4.518-2.286-4.518m4.571 0-.703-2.29V4h-3.165v2.043l-.703 2.29m4.571 0h-4.571" })));
}
const DrillingRigCustom = forwardRef(_DrillingRigCustom);
export { DrillingRigCustom };
